export default __webpack_public_path__ + "static/IT-support-b3888a6ef2fb38108a06a0c22de8da4d.jpg";